function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.278 2.521a1.962 1.962 0 013.444 0l5.009 8.915c.765 1.362-.192 3.064-1.722 3.064H2.99c-1.53 0-2.487-1.702-1.722-3.064L6.28 2.52zm2.505.558a.892.892 0 00-1.566 0l-5.009 8.914c-.347.619.087 1.393.783 1.393H13.01c.695 0 1.13-.774.782-1.393L8.784 3.079zM8 5.957c.3 0 .542.25.542.557V8A.55.55 0 018 8.557.55.55 0 017.458 8V6.514A.55.55 0 018 5.957zm-.542 5.014A.55.55 0 018 10.414h.007c.3 0 .542.25.542.557a.55.55 0 01-.542.558H8a.55.55 0 01-.542-.558z",
  fill: "#2D2D2D"
});
function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default __webpack_public_path__ + "/img/Warning.svg";
export { SvgWarning as ReactComponent };